import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Instagram } from "lucide-react";
import { useLang } from "@/i18n";
import { LINKEDIN_URL, INSTAGRAM_URL } from "@/config";

const Footer = () => {
  const { d } = useLang();
  return (
    <footer className="bg-ink text-paper" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-serif text-3xl font-light tracking-tight">
              Marketing <span className="italic text-accent-bright">Facile</span>
            </p>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.3em] text-white/50">
              Cristina Angelini
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">{d.footer.claim}</p>
            <div className="mt-6 flex items-center gap-3">
              <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-link-linkedin" className="flex h-10 w-10 items-center justify-center border border-white/20 text-white/70 transition-colors duration-300 hover:border-accent hover:bg-accent hover:text-white">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-link-instagram" className="flex h-10 w-10 items-center justify-center border border-white/20 text-white/70 transition-colors duration-300 hover:border-accent hover:bg-accent hover:text-white">
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">{d.footer.navTitle}</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                [d.nav.home, "/"],
                [d.nav.mb, "/marketing-branding"],
                [d.nav.fiere, "/fiere-eventi-lanci"],
                [d.nav.services, "/servizi"],
                [d.nav.cs, "/case-study"],
                [d.nav.about, "/chi-sono"],
                [d.nav.checkup, "/check-up"],
                [d.nav.site, "/sito-essenziale"],
              ].map(([label, path]) => (
                <li key={path}>
                  <Link to={path} className="inline-block py-2.5 text-white/70 transition-colors hover:text-accent-bright" data-testid={`footer-link-${path === "/" ? "home" : path.slice(1)}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">{d.footer.startTitle}</p>
            <p className="mt-5 text-sm leading-relaxed text-white/60">{d.footer.startBody}</p>
            <Link
              to="/contatti"
              data-testid="footer-cta-contatti"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-accent px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-accent-dark"
            >
              {d.footer.startCta}
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-white/40">{d.footer.rights}</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-link-privacy" className="inline-block py-2 text-xs text-white/40 transition-colors hover:text-accent-bright">
              {d.footer.privacy}
            </Link>
            <Link to="/cookie" data-testid="footer-link-cookie" className="inline-block py-2 text-xs text-white/40 transition-colors hover:text-accent-bright">
              {d.footer.cookie}
            </Link>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/30">{d.footer.tagline}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
